import { Button, Grid, Table, alpha } from '@mui/material'
import { setStageStyle } from '../DealsKanban/setStageStyle'
import { styled } from '@mui/material/styles'
import { renderColorByString } from '../DataGrid/renderColorByString'

export const dialogStyles = theme => ({
  width: '100%',
  backgroundColor: theme.palette.mode === 'dark' ? '' : theme.palette.background.default,
  color: theme.palette.text.primary,
  minHeight: '80vh',
  maxHeight: '95vh',
  // padding: '60px',
  paddingTop: '60px',
  paddingLeft: '60px',
  paddingRight: '60px',
  paddingBottom: '30px',
  '& .MuiDialogContent-root': {
    width: '100%',
    padding: '20px',
  },
  '& .MuiTextField-root': {
    margin: '10px 0',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        // This targets the border of the TextField
        // border: 'none', // Removes the border
      },
      '&:hover fieldset': {
        // border: 'none', // Ensures border is removed on hover
      },
      '&.Mui-focused fieldset': {
        border: '2px solid rgb(159, 176, 219)', // Changes border when focused
        // backgroundColor: '#e3f2fd', // Changes background when focused
      },
    },
  },
  '& .MuiInputBase-root': {
    height: '45px',
    backgroundColor: theme.palette.background.paper,
  },
  '& input[type="number"]': {
    // Hides the up and down arrows on webkit browsers like Chrome, Safari, and Edge
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    // Hides the up and down arrows on Firefox
    '&[type=number]': {
      MozAppearance: 'textfield',
    },
  },
})
export const dealDetailStyles = theme => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
  backgroundColor: theme.palette.mode === 'dark' ? '' : theme.palette.background.default,
  '& .MuiTextField-root': {
    backgroundColor: theme.palette.background.paper,
    margin: '10px 0',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none', // Removes the border
      },
      '&:hover fieldset': {
        border: `1px solid ${theme.palette.divider}`, // Optional: changes border on hover
      },
      '&.Mui-focused fieldset': {
        border: '2px solid rgb(159, 176, 219)', // Changes border when focused
        // backgroundColor: '#e3f2fd', // Changes background when focused
      },
    },
  },
  '& .MuiInputBase-root': {
    height: '45px',
    backgroundColor: theme.palette.background.paper,
  },
  '& input[type="number"]': {
    // Hides the up and down arrows on webkit browsers like Chrome, Safari, and Edge
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    // Hides the up and down arrows on Firefox
    '&[type=number]': {
      MozAppearance: 'textfield',
    },
  },
})

export const dialogContentStyles = {
  width: 'auto',
  maxWidth: '700px',
  margin: '0 auto',
}
export const disabledTextStyles = theme => ({
  backgroundColor: theme.palette.background.paper,
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.4) : theme.palette.background.default,
  },
})
export const contractTextStyles = theme => ({
  // backgroundColor: theme.palette.mode === 'dark' ? 'none' : 'rgb(229, 229, 229)',
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.mode === 'dark' ? 'transparent' : theme.palette.background.default,
    height: '40px',
    // color: setStageStyle(value),
  },
})
export const boxColumnStyles = theme => ({
  display: 'flex',
  flexDirection: 'column',
  padding: 5,
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.paper : '',
})
export const chipTextStyles = theme => ({
  // backgroundColor: theme.palette.mode === 'dark' ? 'none' : 'rgb(229, 229, 229)',
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.mode === 'dark' ? 'transparent' : theme.palette.background.default,
    height: '40px',
    padding: '20px',
    // color: setStageStyle(value),
  },
})

export const SaveButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'rgb(42, 128, 200)',
}))
export const CreateButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'rgb(29, 106, 82)',
}))
export const authorizedChipStyle = theme => ({
  margin: '4px 0',
  fontWeight: 'bolder',
  // color: 'rgb(118, 87, 184)',
  // backgroundColor: '#ebdbfd',
  border: `1.5px solid rgb(118, 87, 184)`,
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.section,
  '& .MuiChip-deleteIcon': {
    // color: 'rgba(0, 0, 0, 0.7)', // Darken the icon color
    display: 'none',
    color: theme.palette.text.secondary, // Darken the icon color
    '&:hover': {
      color: alpha(theme.palette.text.primary, 0.9), // Darken more on hover
      backgroundColor: alpha(theme.palette.text.primary, 0.1), // Add background color on hover
      borderRadius: '50%', // Make it round
    },
  },
  '& .MuiChip-icon': {
    color: theme.palette.text.success, // Add vertical margin to the Chip
  },
})
export const contactChipStyle = theme => ({
  fontWeight: 'bolder',
  // color: 'rgb(204, 91, 14)',
  // backgroundColor: 'rgb(250, 238, 230)',
  border: `1.5px solid rgb(204, 91, 14)`,
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.section,
  '& .MuiChip-deleteIcon': {
    // color: 'rgba(0, 0, 0, 0.7)', // Darken the icon color
    display: 'none',
    color: theme.palette.text.secondary, // Darken the icon color
    '&:hover': {
      color: alpha(theme.palette.text.primary, 0.9), // Darken more on hover
      backgroundColor: alpha(theme.palette.text.primary, 0.1), // Add background color on hover
      borderRadius: '50%', // Make it round
    },
  },
  '& .MuiInputBase-root': {
    padding: '8px 14px', // Add padding to the input container
  },
  '& .MuiChip-root': {
    margin: '4px 0', // Add vertical margin to the Chip
  },
  '& .MuiChip-icon': {
    color: theme.palette.text.success, // Add vertical margin to the Chip
  },
})
export const gridItemStyles = {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
}

export const fieldStyles = fieldBgColor => ({
  width: '100%',
  height: '100%',
  // display: 'flex',
  pb: 1.5,
  alignItems: 'center',
  backgroundColor: fieldBgColor,
  '& .MuiInputBase-input': {
    border: 'none',
    fontSize: '12px', // Adjust input font size
    // backgroundColor: `${fieldBgColor} !important`, // Ensures this color takes priority
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderColor: 'transparent', // Makes the outline invisible
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderColor: 'transparent', // Keeps the outline invisible on focus
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderColor: 'transparent', // Keeps the outline invisible on hover
  },
  '& .MuiInputLabel-root': {
    fontSize: '12px', // Adjust label font size
  },
  '& .MuiInputLabel-shrink': {
    fontSize: '14px', // Adjust label font size when shrunk
  },
})
export const readOnlyFieldStyles = fieldBgColor => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  '& .MuiInputBase-root': {
    pointerEvents: 'none', // Disables interaction
    border: 'none', // Removes border
    backgroundColor: fieldBgColor, // Ensures no background change on focus
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent', // Makes the outline invisible
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent', // Keeps the outline invisible on focus
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent', // Keeps the outline invisible on hover
  },
  backgroundColor: 'transparent', // Ensures no background change on focus
})
export const stageFieldStyles = (stage, fieldBgColor) => ({
  '& .MuiInputBase-input': {
    color: setStageStyle(stage),
    fontWeight: 'bold',
  },
  '& .MuiInputBase-root': {
    pointerEvents: 'none', // Disables interaction
    border: 'none', // Removes border
    backgroundColor: fieldBgColor, // Ensures no background change on focus
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent', // Makes the outline invisible
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent', // Keeps the outline invisible on focus
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent', // Keeps the outline invisible on hover
  },
  backgroundColor: 'transparent', // Ensures no background change on focus
})

export const typeFieldStyles = (type, fieldBgColor) => ({
  '& .MuiInputBase-input': {
    color: renderColorByString(type),
    fontWeight: 'bold',
  },
  '& .MuiInputBase-root': {
    pointerEvents: 'none', // Disables interaction
    border: 'none', // Removes border
    backgroundColor: fieldBgColor, // Ensures no background change on focus
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent', // Makes the outline invisible
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent', // Keeps the outline invisible on focus
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent', // Keeps the outline invisible on hover
  },
  backgroundColor: 'transparent', // Ensures no background change on focus
})
export const typeSelectStyles = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
}
export const EmptyRow = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.3) : theme.palette.background.default,
  border: '1px dotted', // Use a dotted border
  minHeight: '81px',
  width: '100%',
  height: '100%', // Full height
  display: 'flex', // Enable flexbox
  justifyContent: 'center', // Center horizontally
  alignItems: 'center', // Center vertically
}))

export const EmptyTable = styled(Table)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.1) : theme.palette.background.default,
  border: '1px',
  borderStyle: 'dotted',
  minHeight: '81px',
  height: '81px',
}))
export const feeFieldStyles = fieldBgColor => ({
  '& .MuiFormLabel-root': {
    fontWeight: 'bold',
    color: 'rgba(249, 180, 45, 1)',
    '&.Mui-focused': {
      color: 'rgba(255,255,255)',
      backgroundColor: fieldBgColor, // Ensures no background change on focus
    },
  },
  '& .MuiInputBase-input': {
    border: 'none',
    fontSize: '14px', // Adjust input font size
    // backgroundColor: `${fieldBgColor} !important`, // Ensures this color takes priority
  },
  '& .MuiInputBase-root': {
    alignItems: 'center', // Aligns the text and adornment
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderColor: 'transparent', // Makes the outline invisible
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderColor: 'transparent', // Keeps the outline invisible on focus
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderColor: 'transparent', // Keeps the outline invisible on hover
  },
  '& .MuiInputLabel-root': {
    fontSize: '12px', // Adjust label font size
  },
  '& .MuiInputLabel-shrink': {
    fontSize: '14px', // Adjust label font size when shrunk
  },
})
export const totalsReadOnlyFieldStyles = fieldBgColor => ({
  '& .MuiInputBase-root': {
    pointerEvents: 'none', // Disables interaction
    border: 'none', // Removes border
  },
  '& .MuiInputBase-input': {
    border: 'none',
    fontSize: '14px', // Adjust input font size
    // backgroundColor: `${fieldBgColor} !important`, // Ensures this color takes priority
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderColor: 'transparent', // Makes the outline invisible
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderColor: 'transparent', // Keeps the outline invisible on focus
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderColor: 'transparent', // Keeps the outline invisible on hover
  },
  '& .MuiInputLabel-root': {
    fontSize: '12px', // Adjust label font size
  },
  '& .MuiInputLabel-shrink': {
    fontSize: '14px', // Adjust label font size when shrunk
  },
})
export const dynamicGridSizes = isTallScreen => ({
  contactRecipient: {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12,
  },
  authorizedRecipient: {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12,
  },
  dates: {
    xs: isTallScreen ? 12 : 6,
    sm: isTallScreen ? 12 : 6,
    md: isTallScreen ? 12 : 6,
    lg: isTallScreen ? 12 : 6,
    xl: isTallScreen ? 12 : 6,
  },
  numbers: {
    xs: isTallScreen ? 12 : 6,
    sm: isTallScreen ? 12 : 6,
    md: isTallScreen ? 12 : 6,
    lg: isTallScreen ? 12 : 6,
    xl: isTallScreen ? 12 : 6,
  },
  totalsContainer: {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12,
  },
  implementationFee: {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12,
  },
  noSignature: {
    xs: 6,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12,
  },
  cancelButton: {
    xs: 2,
    sm: 2,
    md: 2,
    lg: 2,
    xl: 6,
  },
  saveButton: {
    xs: 2,
    sm: 2,
    md: 2,
    lg: 2,
    xl: 6,
  },
  requestButton: {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12,
  },
  generateButton: {
    xs: 6,
    sm: 6,
    md: 6,
    lg: 4,
    xl: 12,
  },
  requestContainer: {
    xs: 8,
    sm: 8,
    md: 8,
    lg: 8,
    xl: 12,
  },
})
